import type { PaymentErrorReport } from "./helper";

/**
 * Form flows only: reopen the draft command after a failed payment.
 * Pass `mutateAsync` from `trpc.reOpenCommand.useMutation()` (matches existing tests and tRPC usage).
 */
export async function callReopenCommandOnFormPaymentError(
  reOpenAsync: (args: { commandId: string }) => Promise<unknown>,
  report: PaymentErrorReport
): Promise<void> {
  const isPaymentSucceeded = report.isPaymentSucceeded ?? false;
  if (report.commandId && !isPaymentSucceeded) {
    await reOpenAsync({ commandId: report.commandId });
  }
}
